const partnerSiteListSelector = state => state.admin.partnerSiteAddDialog.partnerSiteList
const partnerSiteSelector = state => state.admin.partnerSiteAddDialog.partnerSite
const segmentSelector = state => state.admin.partnerSiteAddDialog.segment
const lineSelector = state => state.admin.partnerSiteAddDialog.line
const partnerNameSelector = state => state.admin.partnerSiteAddDialog.partnerName
const odmSelector = state => state.admin.partnerSiteAddDialog.odm
const customerClassSelector = state => state.admin.partnerSiteAddDialog.customerClass
const segmentListSelector = state => state.admin.partnerSiteAddDialog.segmentList
const lineListSelector = state => state.admin.partnerSiteAddDialog.lineList
const isPartnerSiteLoadingSelector = state => state.admin.partnerSiteAddDialog.isPartnerSiteLoading
const aeRegionSelector = state => state.admin.partnerSiteAddDialog.aeRegion
const aeRegionListSelector = state => state.admin.partnerSiteAddDialog.aeRegionList

export {
  partnerSiteListSelector,
  partnerSiteSelector,
  segmentSelector,
  lineSelector,
  partnerNameSelector,
  odmSelector,
  customerClassSelector,
  segmentListSelector,
  lineListSelector,
  isPartnerSiteLoadingSelector,
  aeRegionSelector,
  aeRegionListSelector
}
